// Small shared helpers for the public Guides feature (GuidesListPage,
// GuideDetailPage, GuideCard). The canonical URL builders live in
// shared/seo/paths.mjs — the ONE definition, also used by the server's
// canonical/og:url/sitemap output — re-exported here so existing call sites
// keep importing from "../utils/posts".
export { guidesListPath, guideDetailPath } from "../shared/seo/paths.mjs";

// Post.postType is an internal enum (guide | itinerary | roundup | story) —
// never shown to visitors verbatim. Labels are resolved via translations so
// they stay in sync with the current language; falls back to the raw
// postType (capitalized) for forward-compatibility with a type this map
// doesn't know about yet, rather than showing nothing.
export const postTypeLabel = (t, postType) => {
  const map = {
    guide: t.guideTypeGuide,
    itinerary: t.guideTypeItinerary,
    roundup: t.guideTypeRoundup,
    story: t.guideTypeStory,
  };
  if (map[postType]) return map[postType];
  if (!postType) return t.guideTypeGuide;
  return postType.charAt(0).toUpperCase() + postType.slice(1);
};
